import { useSuspenseQuery } from "@tanstack/react-query";
import { Ajustes } from "@/components/casca/Ajustes";
import { Aviso } from "@/components/casca/formulario";
import { EditorModelos } from "@/components/modelos/EditorModelos";
import { modelosQuery } from "../consultas";

/** Mensagens prontas — e o único jeito de falar com quem está fora da janela de 24h na oficial. */
export function Modelos() {
  const {
    data: { modelos, personalizados, semTabela, custoUSD },
  } = useSuspenseQuery(modelosQuery());
  return (
    <Ajustes
      titulo="Modelos de mensagem"
      descricao="Mensagens prontas para a equipe mandar com um clique — e o único jeito de falar com quem está fora da janela de 24 horas na API oficial."
    >
      {semTabela && (
        <Aviso tom="alerta" titulo="A tabela de modelos ainda não existe no banco.">
          Aplique <code className="rounded bg-black/10 px-1">supabase/migrations/0002_modelos.sql</code> no SQL Editor do Supabase. Até lá, os
          modelos padrão continuam funcionando, mas não dá para editar.
        </Aviso>
      )}
      <EditorModelos modelos={modelos} personalizados={personalizados} custoUSD={custoUSD} />
    </Ajustes>
  );
}
